import axios from "axios"

/**
 * Fetches the list of bots allowed for a specific user.
 * @param {string} userId - The unique identifier of the user.
 * @returns {Promise<any>} A promise that resolves to the user's allowed bots data.
 */
export const fetchUserBots = async (userId: string) => {
    try {
        const base = '';
        const options = {
            headers: {
                'Content-Type': 'application/json',
            },
        }
        const endpoint = base + `/api/users/${userId}/bots`;
        const result = await axios.get(endpoint, options);
        //console.log(result.data);
        return result.data;
    }
    catch (error) {
        console.error('Error fetching allowed bots:', error);
    }
}

/**
 * Sends a chat message to the backend.
 * @param {string} message - The message text to send.
 * @param {string | null} sessionId - The current session ID, if any.
 * @param {string | null} agentId - The ID of the agent being messaged.
 * @returns {Promise<any>} A promise that resolves to the chat response.
 */
export const sendMessage = async (message: string, sessionId: string | null, agentId: string | null) => {
    try {
        const base = '';
        const options = {
            headers: {
                'Content-Type': 'application/json',
            },
        }
        const endpoint = base + '/api/chat';
        const payload = { message, sessionId, agentId };
        const result = await axios.post(endpoint, payload, options);
        //console.log(result.data);
        return result.data;
    }
    catch (error) {
        console.error('Error sending message:', error);
    }
}

/**
 * Retrieves the chat history for a specific session.
 * @param {string} sessionId - The unique identifier for the chat session.
 * @returns {Promise<any>} A promise that resolves to the session's message history.
 */
export const getChatHistory = async (sessionId: string) => {
    try {
        const base = '';
        const options = {
            headers: {
                'Content-Type': 'application/json',
            },
        }
        const endpoint = base + `/api/chat/history/${sessionId}`;
        const result = await axios.get(endpoint, options);
        //console.log(result.data);
        return result.data;
    }
    catch (error) {
        console.error('Error fetching chat history:', error);
    }
}

/**
 * Fetches all conversation IDs for the current user.
 * @returns {Promise<any>} A promise that resolves to a list of conversation sessions.
 */
export const getConversationIds = async () => {
    try {
        const base = '';
        const options = {
            headers: {
                'Content-Type': 'application/json',
            },
        }
        const endpoint = base + `/api/chat/conversations`;
        const result = await axios.get(endpoint, options);
        //console.log(result.data);
        return result.data;
    }
    catch (error) {
        console.error('Error fetching conversation IDs:', error);
    }
}

/**
 * Updates the chat history (Placeholder).
 */
export const updateChatHistory = async () => {

}

/**
 * Deletes the chat history for a specific session.
 * @param {string} sessionId - The unique identifier for the chat session to delete.
 * @returns {Promise<any>} A promise that resolves when the deletion is complete.
 */
export const deleteChatHistory = async (sessionId: string) => {
    try {
        const base = '';
        const options = {
            headers: {
                'Content-Type': 'application/json',
            },
        }
        const endpoint = base + `/api/chat/history/${sessionId}`;
        const result = await axios.delete(endpoint, options);
        console.log(result.data);
        return result.data;
    }
    catch (error) {
        console.error('Error deleting chat history:', error);
    }
}

/**
 * Deletes all chat history for the current user.
 * @returns {Promise<any>} A promise that resolves when the deletion is complete.
 */
export const deleteAllChatHistory = async () => {
    try {
        const base = '';
        const options = {
            headers: {
                'Content-Type': 'application/json',
            },
        }
        const endpoint = base + `/api/chat/history`;
        const result = await axios.delete(endpoint, options);
        console.log(result.data);
        return result.data;
    }
    catch (error) {
        console.error('Error deleting all chat history:', error);
    }
}

/**
 * Initiates the login process by redirecting to the OIDC provider.
 */
export const login = async() => {
    try {
        const base = '';
        const options = {
            headers: {
                'Content-Type': 'application/json',
            },
        }
        const endpoint = base + `/api/auth/login`;
        const result = await axios.get(endpoint, options);
        console.log(result.data);
        const { redirectUrl } = result.data;
        if (redirectUrl) {
            // Redirect the user's browser to the OIDC provider
            window.location.href = redirectUrl;
        }
    }
    catch (error) {
        console.error('Error logging in:', error);
    }
}

/**
 * Initiates the logout process by redirecting to the OIDC provider logout URL.
 */
export const logout = async() => {
    try {
        const base = '';
        const options = {
            headers: {
                'Content-Type': 'application/json',
            },
        }
        const endpoint = base + `/api/auth/logout`;
        const result = await axios.get(endpoint, options);
        console.log(result.data);
        const { redirectUrl } = result.data;
        if (redirectUrl) {
            // Redirect the user's browser to the OIDC provider logout
            window.location.href = redirectUrl;
        }
    }
    catch (error) {
        console.error('Error logging in:', error);
    }
}

/**
 * Fetches the currently authenticated user's information.
 * @returns {Promise<any>} A promise that resolves to the authenticated user's data.
 */
export const fetchUser = async () => {
try {
        const base = '';
        const options = {
            headers: {
                'Content-Type': 'application/json',
            },
        }
        const endpoint = base + `/api/auth/user`;
        const result = await axios.get(endpoint, options);
        console.log(result.data);
        return result.data
    }
    catch (error) {
        console.error('Error logging in:', error);
    }
}
